function vzDropcapInit() {
  const vzDropcap = jQuery('.dropcap');
  vzDropcap.parent().addClass('dropcap-parent');
}
